import { Theme } from '@mui/material/styles';

export const CONTEXT_MENU_DESIGN = {
  paperBg: '#FFFFFF',
  paperRadius: '0.875rem',
  paperShadow: '0 0.0625rem 0.25rem 0.0625rem rgba(0, 0, 0, 0.1)',
  paperPadding: '0.5rem',
  listGap: '0.5rem',
  itemGap: '0.3125rem',
  itemPadding: '0.25rem 0.5rem',
  itemRadius: '0.5rem',
  itemHoverBg: 'rgba(0, 0, 0, 0.04)',
  iconSize: '0.9375rem',
} as const;

export const getContextMenuPaperSx = (theme: Theme) => ({
  backgroundColor: CONTEXT_MENU_DESIGN.paperBg,
  borderRadius: CONTEXT_MENU_DESIGN.paperRadius,
  boxShadow: CONTEXT_MENU_DESIGN.paperShadow,
  padding: `${CONTEXT_MENU_DESIGN.paperPadding} !important`,

  '& .MuiList-root': {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: CONTEXT_MENU_DESIGN.listGap,
    minWidth: 'auto',
  },

  '& .MuiDivider-root': {
    borderColor: theme.palette.grey[100],
    margin: '0 !important',
  },

  '& .MuiDivider-root:last-child': {
    display: 'none',
  },
});

export const getContextMenuItemSx = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  gap: CONTEXT_MENU_DESIGN.itemGap,
  minHeight: 'unset',
  padding: CONTEXT_MENU_DESIGN.itemPadding,
  borderRadius: CONTEXT_MENU_DESIGN.itemRadius,
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.25,
  color: 'var(--Typography-h-secondary, #504E5A) !important',

  '& .MuiListItemIcon-root': {
    margin: '0 !important',
    minWidth: `${CONTEXT_MENU_DESIGN.iconSize} !important`,
    width: CONTEXT_MENU_DESIGN.iconSize,
    color: `${theme.palette.grey[600]} !important`,

    '& > svg': {
      width: CONTEXT_MENU_DESIGN.iconSize,
      height: CONTEXT_MENU_DESIGN.iconSize,
    },
  },

  '& .MuiListItemText-root': {
    margin: 0,
    color: 'inherit !important',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    whiteSpace: 'nowrap',
  },

  '& .MuiListItemText-primary': {
    color: 'inherit !important',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
  },

  '&:hover': { backgroundColor: CONTEXT_MENU_DESIGN.itemHoverBg },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': { backgroundColor: CONTEXT_MENU_DESIGN.itemHoverBg },
  },
});
